module.exports = __webpack_public_path__ + "static/monster-roster-5e87061b74939fcc23f5af446edf3791.png";